import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { setAppConfig } from "./Bifrost/api";
import { Base_Url } from "./Constant/ApiRoutes";
import { getEnv } from "./utils";

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_MSW_ENABLE !== 'true') {
    return
  }
  const { worker } = await import('./mocks');
 
  return worker.start()
}

const root = ReactDOM.createRoot(document.getElementById("root"));
const { app_env, tier } = getEnv();
setAppConfig(Base_Url, app_env, tier);

if (tier === 'sit' || tier === "production") {
  root.render(<App />);
} else {
  enableMocking().then(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
